import React, { useEffect, useState } from "react";
import {
  allCustomers,
  allHotels,
  registerUser,
} from "../../../../api/admin/hotel";
import AddCustomers from "./AddCustomers";
import toast from "react-hot-toast";

const SelectCustomers = ({
  setCustomerId,
  CustomerId,
  setSelectedCustomer,
  SelectedCustomer,
}) => {
  const [Data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [Show, setShow] = useState(false);
  const [Search, setSearch] = useState("");
  const [FormData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    password: "123456",
    isCustomer: 1,
    isWelcomed: 1,
    status: 1,
    createdAt: new Date().toISOString(),
  });
  useEffect(() => {
    allCustomers(setData);
  }, []);
  const handleShow = () => {
    setShow(!Show);
  };
  useEffect(() => {
    if (Search.trim() === "") {
      setFilteredData(Data);
    } else {
      const result = Data.filter((item) =>
        item.fullName.toLowerCase().includes(Search.toLowerCase()),
      );
      setFilteredData(result);
    }

    if (CustomerId) {
      const selected = Data.find((item) => item.CustomerId === CustomerId);
      setSelectedCustomer(selected);
    }
  }, [Search, Data, CustomerId]);

  const handleSelect = (item) => {
    const id = item.CustomerId;
    setSelectedCustomer(item);
    setCustomerId(id);
    setShow(false);
  };
  const handleSubmit = () => {
    if (
      FormData.fullName === "" ||
      FormData.email === "" ||
      FormData.phoneNumber === "" ||
      FormData.password === ""
    ) {
      toast.error("Please fill all the fields");
    } else {
      registerUser(FormData, setFormData, setData);
    }
  };
  return (
    <>
      <div className="flex gap-2">
        <div className="w-full relative">
          <div
            onClick={handleShow}
            className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm cursor-pointer select-none flex justify-start items-center gap-3 bg-white"
          >
            {SelectedCustomer ? (
              <>
                <div className="flex gap-x-2 justify-start items-center">
                  <p className="text-sm font-medium uppercase">
                    {SelectedCustomer.fullName || ""} (
                    {SelectedCustomer.phoneNumber || ""})
                  </p>
                </div>
              </>
            ) : (
              <div>
                <p>Select Customer</p>
              </div>
            )}
          </div>
          {Show && (
            <div className="bg-white w-full max-h-[300px] overflow-y-auto p-3 absolute top-10 drop-shadow-lg left-1/2 -translate-x-1/2 rounded-lg z-10 border scrollbar-hide">
              <div className="space-y-3">
                <div>
                  <input
                    type="text"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Search by name"
                    onChange={(e) => setSearch(e.target.value)}
                    value={Search}
                  />
                </div>
                <div>
                  {Data &&
                    filteredData.map((item, index) => {
                      return (
                        <div
                          key={index}
                          onClick={() => handleSelect(item)}
                          className="flex gap-2 justify-start items-center bg-white hover:bg-[#d7eaff] p-2 rounded-lg cursor-pointer"
                        >
                          <div className="flex gap-x-2 justify-start items-center">
                            <p className="text-sm font-medium uppercase">
                              {item.fullName} ({item.phoneNumber})
                            </p>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
        </div>
        <AddCustomers
          setFormData={setFormData}
          FormData={FormData}
          handleSubmit={handleSubmit}
        />
      </div>
    </>
  );
};

export default SelectCustomers;
